import { PriceSetSchema } from "@redotech/redo-common-model-money-common/price-set";
import * as z from "zod";

export const NewOrderDiscountKinds = ["code", "automatic", "other"] as const;
export type NewOrderDiscountKind = (typeof NewOrderDiscountKinds)[number];

export const NewOrderDiscountLevels = ["item", "order", "shipping"] as const;
export type NewOrderDiscountLevel = (typeof NewOrderDiscountLevels)[number];

/** Persisted kinds may predate the current enum; unknown values degrade to "other". */
export const isNewOrderDiscountKind = (
  value: string,
): value is NewOrderDiscountKind =>
  (NewOrderDiscountKinds as readonly string[]).includes(value);

/**
 * Provider-reported discounts on an exchange new order: which discounts
 * applied (applications) and how they spread across items (allocations).
 */
export const NewOrderDiscountDetailsSchema_ = z.object({
  applications: z.array(
    z.object({
      index: z.number(),
      kind: z.enum(NewOrderDiscountKinds),
      /** Raw provider code; Redo-generated -RETURN codes resolved into displayLabel. */
      code: z.string().nullish(),
      displayLabel: z.string(),
      level: z.enum(NewOrderDiscountLevels),
      summary: z.string().nullish(),
      totalAmountSet: PriceSetSchema.nullish(),
    }),
  ),
  allocations: z.array(
    z.object({
      applicationIndex: z.number(),
      /** Index into newOrderData.items / advancedExchangeItems; absent = order-level. */
      lineIndex: z.number().nullish(),
      amountSet: PriceSetSchema,
    }),
  ),
});

export type SerializedNewOrderDiscountDetails = z.infer<
  typeof NewOrderDiscountDetailsSchema_
>;
export const NewOrderDiscountDetailsSchema: z.ZodType<SerializedNewOrderDiscountDetails> =
  NewOrderDiscountDetailsSchema_;
